import { compatWrapper, convertLegacyPlugin } from '@backstage/core-compat-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import {
  harborPlugin,
  isHarborAvailable,
} from '@digitalist-open-cloud/backstage-plugin-harbor';
import { tipsPlugin } from '@dweber019/backstage-plugin-tips';
import { componentVariants, onVariants } from './variants';

/*
 * Plugins with no new frontend system export. `convertLegacyPlugin` keeps
 * their legacy plugin id and registers their APIs (`plugin.harbor.service`,
 * `plugin.tips.config`); the entity UI is attached as app-defined extensions.
 */

const harbor = convertLegacyPlugin(harborPlugin, {
  extensions: [
    EntityCardBlueprint.make({
      name: 'widget',
      params: {
        type: 'info',
        filter: onVariants(componentVariants, isHarborAvailable),
        loader: () =>
          import('@digitalist-open-cloud/backstage-plugin-harbor').then(m =>
            compatWrapper(<m.HarborWidget />),
          ),
      },
    }),
    EntityContentBlueprint.make({
      name: 'harbor',
      params: {
        path: '/harbor',
        title: 'Harbor',
        filter: onVariants(['service'], isHarborAvailable),
        loader: () =>
          import('@digitalist-open-cloud/backstage-plugin-harbor').then(m =>
            compatWrapper(<m.HarborPage />),
          ),
      },
    }),
  ],
});

const tips = convertLegacyPlugin(tipsPlugin, {
  extensions: [
    // The package's `EntityTipsDialog` export is a legacy routable extension
    // (mount point `tips.root`) whose route is never mounted in the new
    // frontend system, so it throws when rendered. The component it lazily
    // wraps has no routing dependency and is rendered directly. It shows a
    // floating button and a dialog, so it takes no space in the layout.
    EntityCardBlueprint.make({
      name: 'dialog',
      params: {
        type: 'content',
        loader: () =>
          import(
            '@dweber019/backstage-plugin-tips/dist/components/EntityTipsDialog/index.esm.js'
          ).then(m => compatWrapper(<m.EntityTipsDialog />)),
      },
    }),
  ],
});

/** Legacy plugins installed through `convertLegacyPlugin`. */
export const convertedLegacyPlugins = [harbor, tips];
